import { render } from "./HistoryRecordCard.vue?vue&type=template&id=31c84c68&scoped=true&ts=true"
import script from "./HistoryRecordCard.vue?vue&type=script&lang=ts"
export * from "./HistoryRecordCard.vue?vue&type=script&lang=ts"

import "./HistoryRecordCard.vue?vue&type=style&index=0&id=31c84c68&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31c84c68"]])

export default __exports__